import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../../../Activity/Create_Assessment_Activity/create/createActivity.css";
import axios from "../../../../axios";
import Form from "react-bootstrap/Form";
import AttachActivity from "./AttachActivity";
import FirstCreatepublishA from "../create_published/FirstCreatepublishA";
import { IoIosArrowBack } from "react-icons/io";
import assets from "../../../../assets/assets";
import { toast } from "react-toastify";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Chip,
  Paper,
  Radio,
  Button,
} from "@mui/material";
import {
  Box,
  CircularProgress,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { Link, FlaskConical } from "lucide-react";
import Camera from "react-html5-camera-photo";
import AddLinkPopup from "../../../../ContentManagement/LiveSession/LiveSessionDetail.js/SubjectDatailsCM/AddLinkPopup";

function CreateActivity() {
  let general_role = localStorage.getItem("general_role");
  let generalRole_JSON = JSON.parse(general_role);

  let classTeacher = localStorage.getItem("role_as_class_teacher");
  let classTeacher_JSON = JSON.parse(classTeacher);

  let cordinator = localStorage.getItem("role_as_co_ordinator");
  let cordinator_JSON = JSON.parse(cordinator);
  const navigate = useNavigate();
  const { state } = useLocation();
  const [click, setClick] = useState();
  const [difficulty, setDifficulty] = useState([]);
  const [exceed, setExceed] = useState(false);
  const [attach, setAttach] = useState([]);
  const [attachMent, setAttachment] = useState([]);
  const [attachMent2, setAttachment2] = useState([]);
  const [attach2, setAttach2] = useState([]);
  const [isValidFileType, setIsValidFileType] = useState(true);
  const [isValidFileType2, setIsValidFileType2] = useState(true);
  const [loader, setLoader] = useState(false);
  const [loader2, setLoader2] = useState(false);
  const [errorsize, setErrorSize] = useState(false);
  const [isCameraOpen, setIsCameraOpen] = useState(false);
  const [showLinkBox, setShowLinkBox] = useState(false);
  const [linkValue, setLinkValue] = useState("");
  const [activityLabsData, setActivityLabsData] = useState([]);
  const [labsLoading, setLabsLoading] = useState(false);

  // New state for grades
  const [gradeScales, setGradeScales] = useState([]);
  const [selectedGradeScale, setSelectedGradeScale] = useState(null);
  const [entryType, setEntryType] = useState("Marks"); // Default to Marks
  const [manualMarks, setManualMarks] = useState("");

  /* ── Activity Labs State (single selection) ── */
  const [activityLabsOpen, setActivityLabsOpen] = useState(false);
  const [selectedLab, setSelectedLab] = useState(null);
  const [labSearch, setLabSearch] = useState("");
  const [visibleLabsCount, setVisibleLabsCount] = useState(10);

  let Teacher_id = localStorage.getItem("Teacher_id");
  const timeTableSessionId = JSON.parse(
    localStorage.getItem("timeTableSessionId"),
  );
  const academicSessionId = JSON.parse(
    localStorage.getItem("academicYearSessionId"),
  );
  let Teacher_Json = JSON.parse(Teacher_id);

  const schoolId = JSON.parse(localStorage.getItem("schoolId"));

  const [activityState, setActivityState] = useState({
    tmarks: "",
    tittle: "",
    subjects: "",
    sections: "",
    classes: "",
    book: "",
    chapters: "",
    description: "",
    attach: [],
    difficultyLevel: "",
    duration: "",
    correctAnswer: {
      explanation: "",
      attachment: [],
    },
  });
  const {
    tmarks,
    tittle,
    subjects,
    sections,
    classes,
    chapters,
    description,
    difficultyLevel,
    duration,
    book,
    correctAnswer,
  } = activityState;

  let newActivity = {
    standard_name: classes.split(",")[0],
    subject_name: subjects.split(",")[0],
    section_name: sections.split(",")[0],
  };

  // Fetch grade scales
  useEffect(() => {
    const fetchGradeScales = async () => {
      try {
        const res = await axios.get(
          `/api/v1/performance/grade-scales?schoolId=${schoolId}`,
        );
        if (res.data.success && res.data.data.length > 0) {
          setGradeScales(res.data.data);
          // Auto-select first grade scale if available
          setSelectedGradeScale(res.data.data[0]);
        }
      } catch (error) {
        console.error("Error fetching grade scales:", error);
      }
    };
    fetchGradeScales();
  }, []);

  console.log(gradeScales, "GradeScales");

  useEffect(() => {
    const data = JSON.parse(localStorage.getItem("ActivityLocalStorageData"));
    if (!data) return;
    if (data) {
      setActivityState(data);
    }
  }, []);

  const saveTimer = useRef(null);
  const prevStateRef = useRef(activityState);

  useEffect(() => {
    const isSame =
      JSON.stringify(prevStateRef.current) === JSON.stringify(activityState);
    if (isSame) return;
    if (saveTimer.current) clearTimeout(saveTimer.current);
    saveTimer.current = setTimeout(() => {
      localStorage.setItem(
        "ActivityLocalStorageData",
        JSON.stringify(activityState),
      );
      prevStateRef.current = activityState;
    }, 5000);
    return () => {
      if (saveTimer.current) clearTimeout(saveTimer.current);
    };
  }, [activityState]);

  useEffect(() => {
    const fetchLabs = async () => {
      try {
        setLabsLoading(true);
        const res = await axios.get("/api/v1/labActivity/get");
        setActivityLabsData(res?.data?.data || []);
      } catch (error) {
        console.log(error);
        setActivityLabsData([]);
      } finally {
        setLabsLoading(false);
      }
    };

    fetchLabs();
  }, []);

  const validateFileType = (filePath) => {
    var allowedExtensions =
      /(\.jpg|\.jpeg|\.png|\.pdf|\.mp3|\.mp4|\.pptx|\.ppt)$/i;
    if (!allowedExtensions.exec(filePath.name) || attach.length >= 5) {
      setIsValidFileType(false);
      return false;
    }
    setIsValidFileType(true);
    return true;
  };

  const validateFileTypeForCorrectAns = (filePath) => {
    var allowedExtensions =
      /(\.jpg|\.jpeg|\.png|\.pdf|\.mp3|\.mp4|\.pptx|\.ppt)$/i;
    if (!allowedExtensions.exec(filePath.name) || attach2.length >= 5) {
      setIsValidFileType2(false);
      return false;
    }
    setIsValidFileType2(true);
    return true;
  };

  const [dropdowns, setDropdowns] = useState({
    chapterDropdown: [],
  });
  const { chapterDropdown } = dropdowns;
  const [subjectsList, setSubjectsList] = useState([]);

  useEffect(() => {
    setVisibleLabsCount(10);
  }, [labSearch]);

  useEffect(() => {
    const getAllDropdown = async () => {
      try {
        const chapter = await axios.get(
          `/api/v1/cm/library/book/getBookByClassSectionSubject?standard_id=${
            classes.split(",")[1]
          }&section_id=${sections.split(",")[1]}&subject_id=${
            subjects.split(",")[1]
          }&timetableSessionId=${timeTableSessionId}`,
        );
        chapter &&
          setDropdowns({
            chapterDropdown: chapter.data.data,
          });
      } catch (error) {}
    };
    if (classes && sections && subjects) {
      getAllDropdown();
    }
  }, [classes, sections, subjects]);

  useEffect(() => {
    const helper = async () => {
      const difficult = await axios.get("/api/v1/difficultyLevel/get");
      difficult && setDifficulty(difficult.data.data);
    };
    helper();
  }, []);

  useEffect(() => {
    let dummyArr = [];
    (async () => {
      try {
        function addUniqueObjectToArray(obj) {
          if (
            !dummyArr.some(
              (item) => JSON.stringify(item) === JSON.stringify(obj),
            )
          ) {
            dummyArr.push(obj);
          }
        }
        let subjects = [];
        if (classTeacher_JSON?.length > 0 || cordinator_JSON?.length > 0) {
          subjects = await getSubjects(
            classes.split(",")[1],
            sections.split(",")[1],
          );
        }
        if (classTeacher_JSON?.length > 0) {
          classTeacher_JSON?.forEach(async (obj) => {
            if (
              obj.standard_id.id === classes.split(",")[1] &&
              obj.section_id.id === sections.split(",")[1]
            ) {
              subjects.map((obj) => addUniqueObjectToArray(obj));
            }
          });
        }
        if (cordinator_JSON?.length > 0) {
          cordinator_JSON?.forEach(async (obj) => {
            if (
              obj.standard_id.id === classes.split(",")[1] &&
              obj.section_id.id === sections.split(",")[1]
            ) {
              subjects.map((obj) => addUniqueObjectToArray(obj));
            }
          });
        }
        if (generalRole_JSON.length > 0) {
          generalRole_JSON?.forEach((obj) => {
            if (
              obj.standard_id.id === classes.split(",")[1] &&
              obj.section_id.id === sections.split(",")[1]
            ) {
              obj?.subjects_id?.map((para) => addUniqueObjectToArray(para));
            }
          });
        }
        setSubjectsList(dummyArr);
      } catch (error) {
        console.log(error);
      }
    })();
  }, [classes, sections]);

  const getSubjects = async (standard_id, section_id) => {
    let arrSubject = [];
    try {
      if (standard_id && section_id) {
        let res = await axios.get(
          `/api/v1/school/standardId/${standard_id}/sectionId/${section_id}/getSubjects`,
        );

        const data = res?.data?.data;

        // Priority: subjectConfigurations > subjects
        const subjectSource =
          data?.subjectConfigurations?.length > 0
            ? data.subjectConfigurations.map((item) => item.subject)
            : data.subjects;

        subjectSource.forEach((obj) => {
          arrSubject.push(obj);
        });
      }
    } catch (error) {
      console.log(error);
    }
    return arrSubject;
  };

  let sectionArr = [];
  let standardArr = [];

  const dropDownHelper = () => {
    function addUniqueObjectToArraystand(obj) {
      if (
        !standardArr.some(
          (item) => JSON.stringify(item) === JSON.stringify(obj),
        )
      ) {
        standardArr.push(obj);
      }
    }
    generalRole_JSON?.map((obj) =>
      addUniqueObjectToArraystand(obj.standard_id),
    );
    classTeacher_JSON?.map((obj) =>
      addUniqueObjectToArraystand(obj.standard_id),
    );
    cordinator_JSON?.map((obj) => addUniqueObjectToArraystand(obj.standard_id));
  };
  dropDownHelper();

  let standSecId = state?.standardId
    ? state?.standardId
    : activityState.classes.split(",")[1];

  const handleDropDownSec = () => {
    function addUniqueObjectToArraysect(obj) {
      if (
        !sectionArr.some((item) => JSON.stringify(item) === JSON.stringify(obj))
      ) {
        sectionArr.push(obj);
      }
    }
    generalRole_JSON?.map((obj) => {
      if (obj?.standard_id?.id === standSecId) {
        addUniqueObjectToArraysect(obj.section_id);
      }
    });
    classTeacher_JSON?.map((obj) => {
      if (obj?.standard_id?.id === standSecId) {
        addUniqueObjectToArraysect(obj.section_id);
      }
    });
    cordinator_JSON?.map((obj) => {
      if (obj?.standard_id?.id === standSecId) {
        addUniqueObjectToArraysect(obj.section_id);
      }
    });
  };
  handleDropDownSec();

  // Modified createActivitys object with new fields
  let createActivitys = {
    total_marks: tmarks,
    name: tittle,
    standard_id: classes.split(",")[1],
    subject_id: subjects.split(",")[1],
    section_id: sections.split(",")[1],
    chapter_id: chapters,
    book_id: book,
    academic_session_id: academicSessionId,
    timetable_session_id: timeTableSessionId,
    difficulty_level: difficultyLevel.split(",")[1],
    description,
    attachments: attach,
    attachments_sizeKb: Math.round(attachMent.map((file) => file.size / 1024)),
    duration: duration,
    teacher_id: Teacher_Json,
    activity_type: "Lab",
    lab_ref_id: selectedLab?.id,
    correctAnswer: {
      explanation: correctAnswer.explanation,
      attachment: attach2,
      attachments_sizeKb: Math.round(
        attachMent2.map((file) => file.size / 1024),
      ),
    },
    // New fields for marks/grades
    entryType: entryType,
    gradeScaleId: entryType === "Grade" ? selectedGradeScale?._id : null,
    rubricScaleId: null,
  };

  const helper = async () => {
    try {
      console.warn(createActivitys);
      let res = await axios.post(
        `/api/v1/homework/activity/create`,
        createActivitys,
      );
      console.warn(res);
      navigate("/PublishedHomeworkActivity");
    } catch (error) {
      console.log(error);
    } finally {
      localStorage.removeItem("ActivityLocalStorageData");
    }
  };

  const errors = {};

  const isDisableDraft =
    activityState.tittle === "" ||
    activityState.subjects === "" ||
    activityState.sections === "" ||
    activityState.classes === "" ||
    activityState.chapters === "" ||
    activityState.description === "" ||
    activityState.difficultyLevel === "" ||
    Object.keys(errors).length > 0;

  const isDisableNext =
    activityState.tittle === "" ||
    activityState.subjects === "" ||
    activityState.sections === "" ||
    activityState.classes === "" ||
    activityState.chapters === "" ||
    activityState.description === "" ||
    activityState.difficultyLevel === "" ||
    Object.keys(errors).length > 0;

  function checkFileSize(event) {
    event.stopPropagation();
    const file = event.target.files[0];
    if (!file) {
      setLoader(false);
      return;
    }
    const maxSize = 10 * 1024 * 1024;
    let totalSize = attachMent.reduce((acc, file) => acc + file.size, 0);
    setLoader(true);
    if (file.size > maxSize) {
      setExceed(true);
      setLoader(false);
      setIsValidFileType(true);
      event.target.value = "";
    } else {
      if (totalSize + file.size <= 10 * 1024 * 1024 && validateFileType(file)) {
        setExceed(false);
        const file = event.target.files[0];
        const formData = new FormData();
        formData.append("uploadActivityAttachment", file);
        axios
          .post(
            `/api/v1/homework/activity/uploadAttachment/teacherId/${Teacher_Json}`,
            formData,
          )
          .then((response) => {
            setAttach([...attach, response.data.data]);
            setAttachment((prev) => [...prev, file]);
            setActivityState((prevState) => ({
              ...prevState,
              attach: [...prevState.attach, response.data.data],
            }));
            response && setLoader(false);
          })
          .catch((error) => {
            console.error("Error uploading file:", error);
            setLoader(false);
            toast.error("Error uploading file");
          });
      } else {
        setIsValidFileType(false);
        setLoader(false);
      }
    }
    event.target.value = "";
  }

  async function handleTakePhoto(dataUri) {
    const now = new Date();
    const day = String(now.getDate()).padStart(2, "0");
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const year = now.getFullYear();
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");
    const fileExtension = "jpg" || "jpeg" || "png";
    const filename = `capture-${day}-${month}-${year}-${hours}:${minutes}:${seconds}.${fileExtension}`;

    const link = document.createElement("a");
    link.href = dataUri;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    try {
      const capture = await fetch(dataUri).then((res) => res.blob());
      const fileWithProperExtension = new File([capture], filename, {
        type: capture.type || "image/jpeg",
      });
      if (
        fileWithProperExtension.size <= 25 * 1024 * 1024 &&
        validateFileType(fileWithProperExtension)
      ) {
        const formData = new FormData();
        formData.append("name", filename);
        formData.append("uploadActivityAttachment", fileWithProperExtension);
        let response = await axios.post(
          `/api/v1/homework/activity/uploadAttachment/teacherId/${Teacher_Json}`,
          formData,
        );
        if (response) {
          setAttach([...attach, response.data.data]);
          setActivityState((prevState) => ({
            ...prevState,
            attach: [...prevState.attach, response.data.data],
          }));
          response && setLoader(false);
        } else {
          console.error("Failed to upload photo:", response.statusText);
          alert("Failed to upload photo.");
        }
      } else {
        setIsValidFileType(false);
      }
    } catch (error) {
      console.error("Error uploading photo:", error);
      alert("An error occurred during the upload.");
    } finally {
      setIsCameraOpen(false);
    }
  }

  function checkFileSizeForAns(event) {
    event.stopPropagation();
    const file = event.target.files[0];
    const maxSize = 10 * 1024 * 1024;
    let totalSize = attachMent2.reduce((acc, file) => acc + file.size, 0);
    setLoader2(true);
    if (file.size > maxSize) {
      setExceed(true);
      setIsValidFileType2(true);
      event.target.value = "";
    } else {
      if (
        totalSize + file.size <= 10 * 1024 * 1024 &&
        validateFileTypeForCorrectAns(file)
      ) {
        setExceed(false);
        const file = event.target.files[0];
        const formData = new FormData();
        formData.append("uploadActivityAttachment", file);
        axios
          .post(
            `/api/v1/homework/activity/uploadAttachment/teacherId/${Teacher_Json}`,
            formData,
          )
          .then((response) => {
            setAttach2([...attach2, response.data.data]);
            setAttachment2((prev) => [...prev, file]);
            setActivityState((prevState) => ({
              ...prevState,
              correctAnswer: {
                ...prevState.correctAnswer,
                attachment: [
                  ...prevState.correctAnswer.attachment,
                  response.data.data,
                ],
              },
            }));
            response && setLoader2(false);
          })
          .catch((error) => {
            setLoader2(false);
            console.error("Error uploading file:", error);
            toast.error("Error uploading file");
          });
      } else {
        setIsValidFileType2(false);
        setLoader2(false);
      }
    }
    event.target.value = "";
  }

  useEffect(() => {
    if (
      standardArr &&
      standardArr.length > 0 &&
      sectionArr &&
      sectionArr.length > 0 &&
      state?.standardId !== undefined &&
      state?.sectionId !== undefined
    ) {
      let standard = standardArr.filter(
        (standard) => standard.id === state.standardId,
      );
      let section = sectionArr.filter(
        (section) => section.id === state.sectionId,
      );
      setActivityState((prev) => {
        return {
          ...prev,
          sections: section[0]["name"] + "," + section[0]["id"],
          classes: standard[0]["name"] + "," + standard[0]["id"],
        };
      });
    }
  }, [state]);

  useEffect(() => {
    if (
      subjectsList &&
      subjectsList.length > 0 &&
      state?.subjectId !== undefined
    ) {
      let subject = subjectsList.filter(
        (subject) => subject.id == state.subjectId,
      );
      if (subject.length > 0) {
        setActivityState((prev) => {
          return {
            ...prev,
            subjects: subject[0]["name"] + "," + subject[0]["id"],
          };
        });
      } else {
        console.error("No matching subject found for the given subjectId.");
      }
    }
  }, [subjectsList, state?.subjectId]);

  const onChangeLinkValue = (value) => {
    setLinkValue(value);
  };

  const handleSaveLink = () => {
    if (linkValue.trim() === "" || !linkValue.startsWith("https://")) {
      toast.error("Please enter a valid link.");
      return;
    }

    // Add to activity state
    setActivityState((prevState) => ({
      ...prevState,
      attach: [...prevState.attach, linkValue],
    }));

    // ALSO sync local attachment arrays
    setAttach((prev) => [...prev, linkValue]);

    setAttachment((prev) => [
      ...prev,
      {
        name: linkValue,
        size: 0,
        isLink: true,
      },
    ]);

    setLinkValue("");
    setShowLinkBox(false);
  };

  const handleBackNavigation = () => {
    if (state?.fromLiveSession === "liveSession") {
      navigate("/liveSession", {
        state: {
          supplement_id: state?.supplement_id,
          addMaterial: state?.redirectStateData?.addMaterial,
          standardId: state?.standardId,
          sectionId: state?.sectionId,
          Subject_id: state?.subjectId ?? state?.Subject_id,
          buttonfunction: state?.redirectStateData?.buttonfunction,
          sectionName: state?.redirectStateData?.sectionName,
          standardsName: state?.redirectStateData?.standardsName,
        },
      });
    } else {
      navigate("/PublishedHomeworkActivity");
    }
  };

  const filteredLabs = activityLabsData.filter((lab) => {
    const matchesSearch =
      (lab.title || "").toLowerCase().includes(labSearch.toLowerCase()) ||
      (lab.description || "").toLowerCase().includes(labSearch.toLowerCase());

    return matchesSearch;
  });

  console.log(selectedLab, "selectedLAb");

  return (
    <>
      {/* ── Animated Background ── */}
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: -1,
        }}
      />
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: -1,

          backdropFilter: "blur(8px)",
        }}
      />

      {/* ── Main Scrollable Container ── */}
      <div
        className="create_all mt-2 orange-scrollBar"
        style={{ height: "600px", overflowY: "scroll" }}
      >
        <div className="d-flex gap-2 align-items-center">
          <IoIosArrowBack
            onClick={handleBackNavigation}
            style={{ cursor: "pointer" }}
          />
          <div
            className="d-flex flex-column gap-1"
            style={{ cursor: "pointer" }}
            onClick={handleBackNavigation}
          >
            <span className="head_manual">Add Activity</span>
            <span className="fw-small text-muted" style={{ fontSize: "10px" }}>
              Dashboard / Assignment / Add Activity
            </span>
          </div>
        </div>

        <div
          className="d-flex flex-column p-4 mt-2 mx-4"
          style={{
            backgroundColor: "rgba(255,255,255,0.95)",
            backdropFilter: "blur(12px)",
            borderRadius: 16,
            border: "1px solid rgba(255,255,255,0.6)",
            boxShadow: "0 8px 32px rgba(0,0,0,0.08)",
          }}
        >
          <div className="mx-4">
            {/* Header with Marks and Grade Options */}
            <div className="d-flex justify-content-between align-items-center mb-3 mx-2">
              <h6 className="poppins-semibold">Add Activity</h6>

              <div className="d-flex align-items-center gap-2">
                {/* Show Grade selection only if grade scales data is available */}
                {gradeScales.length > 0 && (
                  <>
                    <div className="d-flex align-items-center gap-2">
                      <span className="fw-medium" style={{ fontSize: "14px" }}>
                        Entry Type:
                      </span>
                      <select
                        className="form-select form-select-sm"
                        value={entryType}
                        onChange={(e) => {
                          const value = e.target.value;
                          setEntryType(value);
                          if (value === "Marks" && gradeScales.length > 0) {
                            setSelectedGradeScale(gradeScales[0]);
                          }
                        }}
                        style={{ width: "100px", borderRadius: "8px" }}
                      >
                        <option value="Marks">Marks</option>
                        <option value="Grade">Grade</option>
                      </select>
                    </div>

                    {entryType === "Grade" && (
                      <div className="d-flex align-items-center gap-2">
                        <span
                          className="fw-medium"
                          style={{ fontSize: "14px" }}
                        >
                          Grade:
                        </span>
                        <select
                          className="form-select form-select-sm"
                          value={selectedGradeScale?._id || ""}
                          onChange={(e) => {
                            const selected = gradeScales.find(
                              (scale) => scale._id === e.target.value,
                            );
                            setSelectedGradeScale(selected || null);
                          }}
                          style={{ width: "150px", borderRadius: "8px" }}
                        >
                          <option value="">Select Grade Scale</option>
                          {gradeScales.map((scale) => (
                            <option key={scale._id} value={scale._id}>
                              {scale.name}
                            </option>
                          ))}
                        </select>
                        {selectedGradeScale && (
                          <div className="d-flex gap-1">
                            {selectedGradeScale.grades.map((grade) => (
                              <span
                                key={grade.grade}
                                className="badge"
                                style={{
                                  backgroundColor:
                                    grade.resultStatus === "Pass"
                                      ? "#d4edda"
                                      : "#f8d7da",
                                  color:
                                    grade.resultStatus === "Pass"
                                      ? "#155724"
                                      : "#721c24",
                                  padding: "4px 8px",
                                  borderRadius: "4px",
                                  fontSize: "11px",
                                }}
                              >
                                {grade.grade}: {grade.minMarks}-{grade.maxMarks}
                              </span>
                            ))}
                          </div>
                        )}
                      </div>
                    )}
                  </>
                )}

                {/* Marks and Grade Selection - Always show marks, conditionally show grade */}
                {entryType === "Marks" && (
                  <div className="d-flex align-items-center gap-3">
                    {/* Always show Marks input */}
                    <div className="d-flex align-items-center gap-2">
                      <span className="fw-medium" style={{ fontSize: "14px" }}>
                        Marks:
                      </span>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        value={activityState.tmarks}
                        onChange={(e) => {
                          let value = e.target.value;
                          if (/^\d*$/.test(value) || value === "") {
                            if (value === "" || parseInt(value) <= 999) {
                              setActivityState({
                                ...activityState,
                                tmarks: value,
                              });
                            }
                          }
                        }}
                        placeholder="Enter marks"
                        style={{ width: "120px", borderRadius: "8px" }}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Title */}
            <div className="form-group col-md-12 mb-2">
              <input
                className="form-control"
                id="txt-i-first"
                placeholder="Enter title"
                maxLength={100}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value.trim() !== "" || value === "") {
                    setActivityState({
                      ...activityState,
                      tittle: value,
                    });
                  }
                }}
                value={activityState.tittle}
                style={{
                  borderRadius: 12,
                  border: "1px solid #e2e8f0",
                  backgroundColor: "#f8fafc",
                  padding: "12px 16px",
                  fontSize: "0.95rem",
                  transition: "all 0.2s",
                }}
              />
              {errors.tittle && (
                <span className="text-danger">{errors.tittle}</span>
              )}
            </div>

            {/* Class / Section / Subject */}
            <div className="row mt-4 gap-2 mx-2">
              <div className="form-group col-md-4 mb-2">
                <select
                  className="form-select"
                  style={{
                    borderRadius: 12,
                    border: "1px solid #e2e8f0",
                    backgroundColor: "#f8fafc",
                    padding: "10px 14px",
                  }}
                  disabled={state?.defaultData !== undefined}
                  value={classes}
                  onChange={(e) => {
                    setActivityState({
                      ...activityState,
                      classes: e.target.value,
                      sections: "",
                      subjects: "",
                    });
                  }}
                >
                  <option value="">Select Class</option>
                  {standardArr &&
                    standardArr
                      ?.sort((a, b) => {
                        const aNum = Number(a.name);
                        const bNum = Number(b.name);
                        const bothNumeric = !isNaN(aNum) && !isNaN(bNum);
                        if (bothNumeric) return aNum - bNum;
                        return a.name.localeCompare(b.name);
                      })
                      ?.map((item) => (
                        <option key={item.id} value={[item.name, item.id]}>
                          {item.name}
                        </option>
                      ))}
                </select>
              </div>

              <div className="form-group col-md-4 mb-2">
                <select
                  className="form-select"
                  style={{
                    borderRadius: 12,
                    border: "1px solid #e2e8f0",
                    backgroundColor: "#f8fafc",
                    padding: "10px 14px",
                  }}
                  disabled={state?.defaultData !== undefined}
                  value={sections}
                  onChange={(e) =>
                    setActivityState({
                      ...activityState,
                      sections: e.target.value,
                      subjects: "",
                    })
                  }
                >
                  <option value="">Select Section</option>
                  {sectionArr?.map((item) => (
                    <option key={item.id} value={[item.name, item.id]}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group col-md-4 mb-2">
                <select
                  className="form-select"
                  style={{
                    borderRadius: 12,
                    border: "1px solid #e2e8f0",
                    backgroundColor: "#f8fafc",
                    padding: "10px 14px",
                  }}
                  disabled={state?.defaultData !== undefined}
                  value={subjects}
                  onChange={(e) =>
                    setActivityState({
                      ...activityState,
                      subjects: e.target.value,
                      chapters: "",
                    })
                  }
                >
                  <option value="">Select Subject</option>
                  {subjectsList?.map((item) => (
                    <option key={item.id} value={[item.name, item.id]}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* Chapter / Difficulty */}
            <div className="form-group col-md-12 d-flex align-items-center w-100 mt-4 gap-2">
              <select
                className="form-select col-md-6"
                style={{
                  borderRadius: 12,
                  border: "1px solid #e2e8f0",
                  backgroundColor: "#f8fafc",
                  padding: "10px 14px",
                }}
                value={activityState.chapters}
                onChange={(e) =>
                  setActivityState({
                    ...activityState,
                    chapters: e.target.value,
                    book: e.target.options[e.target.selectedIndex].getAttribute(
                      "book-id",
                    ),
                  })
                }
              >
                <option value="">Select Chapter</option>
                {chapterDropdown?.length > 0 &&
                  chapterDropdown?.map((item) =>
                    item.bookInfo.map((book) => (
                      <optgroup
                        label={book.name}
                        key={book.id}
                        book-id={book.id}
                      >
                        {book.chapterData.map((chapter) => (
                          <option
                            key={chapter.id}
                            book-id={book.id}
                            value={chapter.id}
                          >
                            {chapter.chapterName}
                          </option>
                        ))}
                      </optgroup>
                    )),
                  )}
              </select>

              <select
                className="form-select col-md-6"
                style={{
                  borderRadius: 12,
                  border: "1px solid #e2e8f0",
                  backgroundColor: "#f8fafc",
                  padding: "10px 14px",
                }}
                value={activityState.difficultyLevel}
                onChange={(e) =>
                  setActivityState({
                    ...activityState,
                    difficultyLevel: e.target.value,
                  })
                }
              >
                <option>Difficulty Level</option>
                {difficulty &&
                  difficulty.length > 0 &&
                  difficulty.map((subjectList) => (
                    <option
                      key={subjectList.id}
                      value={[subjectList.name, subjectList.id]}
                    >
                      {subjectList.name}
                    </option>
                  ))}
              </select>
            </div>

            {/* Description */}
            <div className="form-group col-md-12 w-100 mt-4">
              <Form.Group controlId="exampleForm.ControlTextarea1">
                <Form.Control
                  as="textarea"
                  value={activityState.description}
                  placeholder="Description"
                  maxLength={1000}
                  rows={6}
                  className="px-3 py-2 descri_activity text-left placeholderColor"
                  onChange={(e) => {
                    const value = e.target.value;

                    if (value.trim() !== "" || value === "") {
                      setActivityState({
                        ...activityState,
                        description: value,
                      });
                    }
                  }}
                  style={{
                    borderRadius: 12,
                    border: "1px solid #e2e8f0",
                    backgroundColor: "#f8fafc",
                    resize: "vertical",
                    overflow: "auto",
                    minHeight: "150px",
                  }}
                />

                {errors.description && (
                  <span className="error">{errors.description}</span>
                )}
              </Form.Group>
            </div>

            {/* ── Selected Activity Lab (full width, below description) ── */}
            {selectedLab && (
              <Paper
                elevation={0}
                sx={{
                  mt: 2,
                  mb: 3,
                  p: 2.5,
                  borderRadius: 3,
                  border: "2px solid #6366f1",
                  backgroundColor: "#f5f3ff",
                  display: "flex",
                  alignItems: "center",
                  gap: 2.5,
                  width: "100%",
                }}
              >
                <Box
                  sx={{
                    width: 140,
                    height: 90,
                    flexShrink: 0,
                    borderRadius: 2,
                    overflow: "hidden",
                    border: "1px solid #c4b5fd",
                    boxShadow: "0 2px 8px rgba(99,102,241,0.15)",
                  }}
                >
                  <img
                    src={selectedLab.thumbnailUrl}
                    alt={selectedLab.title}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                    onError={(e) => {
                      e.target.style.display = "none";
                    }}
                  />
                </Box>

                <Box sx={{ flex: 1, minWidth: 0 }}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      mb: 0.8,
                    }}
                  >
                    <FlaskConical size={18} style={{ color: "#6366f1" }} />
                    <Typography
                      variant="subtitle1"
                      sx={{
                        fontWeight: 700,
                        color: "#4338ca",
                        fontSize: "1.05rem",
                      }}
                    >
                      {selectedLab.title}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      gap: 1,
                      mb: 1,
                      flexWrap: "wrap",
                    }}
                  >
                    <Chip
                      size="small"
                      label={
                        selectedLab?.estimatedDurationMinutes
                          ? `${selectedLab?.estimatedDurationMinutes} mins`
                          : "-"
                      }
                      sx={{
                        backgroundColor: "#e0e7ff",
                        color: "#4338ca",
                        fontWeight: 600,
                        fontSize: "0.75rem",
                        borderRadius: 1.5,
                      }}
                    />
                    <Chip
                      size="small"
                      label={selectedLab.resourceType}
                      sx={{
                        backgroundColor: "#f3e8ff",
                        color: "#7c3aed",
                        fontWeight: 600,
                        fontSize: "0.75rem",
                        borderRadius: 1.5,
                      }}
                    />
                  </Box>
                  <Typography
                    variant="body2"
                    sx={{
                      color: "#64748b",
                      fontSize: "0.82rem",
                      lineHeight: 1.5,
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                    }}
                  >
                    {selectedLab.description}
                  </Typography>
                </Box>

                <IconButton
                  size="small"
                  onClick={() => setSelectedLab(null)}
                  sx={{
                    color: "#6366f1",
                    "&:hover": { backgroundColor: "#e0e7ff" },
                  }}
                >
                  <img
                    src={assets.closeIcon}
                    alt="remove"
                    width={20}
                    height={20}
                  />
                </IconButton>
              </Paper>
            )}

            {/* ── Attachment Toolbar ── */}
            <div
              className="my-2 d-flex align-items-center rounded-3 p-3"
              style={{
                backgroundColor: "rgba(248,250,252,0.95)",
                border: "1px solid #e2e8f0",
                borderRadius: 16,
              }}
            >
              <div style={{ width: "100%" }}>
                {loader ? (
                  <img
                    src="/gif/Loader.gif"
                    alt="Loading..."
                    style={{ width: "32px", height: "32px" }}
                  />
                ) : (
                  <>
                    <Box sx={{ ml: 2 }}>
                      <Stack
                        direction="row"
                        alignItems="center"
                        spacing={3}
                        flexWrap="wrap"
                        useFlexGap
                      >
                        {/* Add Link */}
                        <Box
                          onClick={() => setShowLinkBox(!showLinkBox)}
                          className="cameraContainerActivity"
                          sx={{
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            px: 2,
                            py: 1,
                            borderRadius: 2,
                            backgroundColor: "#ffffff",
                            border: "1px solid #e2e8f0",
                            transition: "all 0.2s",
                            "&:hover": {
                              borderColor: "#6366f1",
                              boxShadow: "0 2px 8px rgba(99,102,241,0.1)",
                            },
                          }}
                        >
                          <Link size={18} style={{ color: "#6366f1" }} />
                          <Typography
                            variant="body2"
                            sx={{
                              fontWeight: 600,
                              color: "#475569",
                              fontSize: "0.85rem",
                            }}
                          >
                            Add Link
                          </Typography>
                        </Box>

                        {/* Upload Files */}
                        <Box
                          sx={{
                            position: "relative",
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                          }}
                        >
                          <input
                            id="attachFile2"
                            type="file"
                            accept=".pdf,.jpg,.jpeg,.png,.mp3,.mp4"
                            style={{ display: "none" }}
                            onChange={(e) => checkFileSize(e)}
                          />
                          <label
                            htmlFor="attachFile2"
                            style={{ cursor: "pointer" }}
                          >
                            <span
                              className="cameraContainerAddAttachment d-flex align-items-center"
                              style={{
                                padding: "8px 16px",
                                borderRadius: 12,
                                backgroundColor: "#ffffff",
                                border: "1px solid #e2e8f0",
                                gap: 8,
                              }}
                            >
                              <img
                                src={assets.UploadIcon}
                                alt=""
                                style={{ width: "20px" }}
                              />
                              <Typography
                                variant="body2"
                                sx={{
                                  fontWeight: 600,
                                  color: "#475569",
                                  fontSize: "0.85rem",
                                }}
                              >
                                Upload files
                              </Typography>
                            </span>
                          </label>
                          {loader && (
                            <CircularProgress
                              size={22}
                              sx={{ ml: 1, color: "#6366f1" }}
                            />
                          )}
                          {(errorsize || !isValidFileType) && (
                            <Typography
                              variant="caption"
                              color="error"
                              sx={{ ml: 2, fontWeight: 500 }}
                            >
                              {errorsize
                                ? "File must be under 10MB"
                                : "Invalid file type"}
                            </Typography>
                          )}
                        </Box>

                        {/* Camera Upload */}
                        {!isCameraOpen ? (
                          <Box
                            onClick={() => setIsCameraOpen(true)}
                            className="d-flex align-items-center gap-2 cameraContainerActivity"
                            sx={{
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                              px: 2,
                              py: 1,
                              borderRadius: 2,
                              backgroundColor: "#ffffff",
                              border: "1px solid #e2e8f0",
                              transition: "all 0.2s",
                              "&:hover": {
                                borderColor: "#6366f1",
                                boxShadow: "0 2px 8px rgba(99,102,241,0.1)",
                              },
                            }}
                          >
                            <img
                              src="/images/CameranewIcon.png"
                              alt=""
                              style={{ width: "24px" }}
                            />
                            <Typography
                              variant="body2"
                              sx={{
                                fontWeight: 600,
                                color: "#475569",
                                fontSize: "0.85rem",
                              }}
                            >
                              Take Photo
                            </Typography>
                          </Box>
                        ) : (
                          <Box
                            className="opened_camera"
                            sx={{
                              mt: 2,
                              width: "100%",
                              position: "relative",
                              borderRadius: 2,
                              border: "1px solid #e0e0e0",
                              boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
                              overflow: "hidden",
                              backgroundColor: "#fafafa",
                            }}
                          >
                            <IconButton
                              onClick={() => setIsCameraOpen(false)}
                              size="small"
                              sx={{
                                position: "absolute",
                                top: 8,
                                right: 8,
                                zIndex: 10,
                                backgroundColor: "rgba(255,255,255,0.8)",
                              }}
                            >
                              <img
                                src={assets.closeIcon}
                                alt="close"
                                width={20}
                                height={20}
                              />
                            </IconButton>
                            <Box sx={{ position: "relative" }}>
                              <Camera
                                onTakePhoto={handleTakePhoto}
                                idealFacingMode="environment"
                                isImageMirror={false}
                                imageCompression={0.97}
                                isMaxResolution={true}
                                isSilentMode={false}
                                className="custom-camera"
                              />
                            </Box>
                          </Box>
                        )}

                        {/* Activity Labs — at the END */}
                        <Box
                          onClick={() => {
                            setActivityLabsOpen(true);
                          }}
                          sx={{
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            px: 2,
                            py: 1,
                            borderRadius: 2,
                            backgroundColor: selectedLab
                              ? "#f5f3ff"
                              : "#ffffff",
                            border: selectedLab
                              ? "2px solid #6366f1"
                              : "1px solid #e2e8f0",
                            transition: "all 0.2s",
                            marginLeft: "auto !important",

                            "&:hover": {
                              borderColor: "#6366f1",
                              boxShadow: "0 2px 8px rgba(99,102,241,0.1)",
                            },
                          }}
                        >
                          <FlaskConical
                            size={18}
                            style={{
                              color: selectedLab ? "#6366f1" : "#64748b",
                            }}
                          />
                          <Typography
                            variant="body2"
                            sx={{
                              fontWeight: 600,
                              color: selectedLab ? "#4338ca" : "#475569",
                              fontSize: "0.85rem",
                            }}
                          >
                            {selectedLab ? "Change Lab" : "Activity Labs"}
                          </Typography>
                        </Box>
                      </Stack>
                    </Box>
                  </>
                )}

                <div className="d-flex p-2 flex-wrap">
                  {activityState?.attach?.map((obj, index) => (
                    <div key={index}>
                      <AttachActivity
                        closeAttach={setActivityState}
                        activityState={activityState}
                        newActivity={newActivity}
                        attachMent={attachMent}
                        attachArr={attach}
                        setAttachment={setAttachment}
                        setAttach={setAttach}
                        attach={obj}
                        indexToRemove={index}
                      />
                    </div>
                  ))}
                </div>

                {exceed && (
                  <p
                    className="text-danger mt-2 mb-0 text-center"
                    style={{ fontSize: "0.85rem", lineHeight: "1.2" }}
                  >
                    Kindly upload file less than <strong>10MB</strong>.
                  </p>
                )}

                {!isValidFileType && (
                  <p
                    className="text-danger mt-2 mb-0 text-center"
                    style={{ fontSize: "0.85rem", lineHeight: "1.2" }}
                  >
                    Please upload a valid file (pdf, jpg, png, pptx, mp3, mp4).
                    Max Limit = 5, Size ≤ 10MB.
                  </p>
                )}
              </div>
            </div>

            {/* Correct Answer */}
            <div className="m-3 mt-2">
              <div
                className="d-flex align-items-center border rounded overflow-hidden"
                style={{ height: "40px", borderRadius: 12 }}
              >
                <input
                  type="text"
                  className="form-control border-0 shadow-none"
                  placeholder="Add Correct Answer"
                  value={activityState.correctAnswer.explanation}
                  maxLength={250}
                  onChange={(e) =>
                    setActivityState((prevState) => ({
                      ...prevState,
                      correctAnswer: {
                        ...prevState.correctAnswer,
                        explanation: e.target.value,
                      },
                    }))
                  }
                  style={{
                    fontSize: "14px",
                    color: "#555",
                    backgroundColor: "#fff",
                    height: "100%",
                  }}
                />
                <input
                  id="attachFile"
                  type="file"
                  accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                  style={{ display: "none" }}
                  onChange={(e) => checkFileSizeForAns(e)}
                />
                <label
                  htmlFor={`attachFile`}
                  style={{
                    color: "#8D4B28",
                    whiteSpace: "nowrap",
                    borderRadius: 20,
                    padding: "6px 16px",
                    cursor: "pointer",
                  }}
                  className="d-flex align-items-center gap-2 poppins-semibold"
                >
                  <span>Choose File</span>
                  <img
                    src={assets.UploadIcon}
                    height="100%"
                    width="25px"
                    alt="Attach Icon"
                    style={{ objectFit: "contain", maxHeight: "100%" }}
                  />
                </label>
              </div>

              {loader2 && (
                <img
                  src="/gif/Loader.gif"
                  style={{ width: "32px", height: "32px", marginTop: "8px" }}
                />
              )}

              {!isValidFileType2 && (
                <p className="text-danger mt-2" style={{ fontSize: "13px" }}>
                  Please upload a valid file (pdf, jpg, jpeg, png, pptx, ppt,
                  mp3, mp4). Max 5 files, total size ≤ 10MB.
                </p>
              )}

              <div
                className="mt-2 p-1 pdf_create_activity d-flex flex-wrap"
                style={{
                  maxHeight:
                    activityState?.correctAnswer?.attachment.length > 3
                      ? "320px"
                      : "160px",
                  overflowY: "auto",
                }}
              >
                {activityState?.correctAnswer?.attachment?.map((obj, index) => (
                  <div key={index} style={{ margin: "10px" }}>
                    <AttachActivity
                      closeAttach={setActivityState}
                      activityState={activityState}
                      newActivity={newActivity}
                      attachMent={attachMent2}
                      attachArr={attach2}
                      setAttachment={setAttachment2}
                      setAttach={setAttach2}
                      attach={obj}
                    />
                  </div>
                ))}
              </div>
            </div>

            {/* Buttons */}
            <div className="d-flex align-items-center justify-content-end">
              <button
                className="btn px-3 m-1 py-2 activity_Draft_button"
                onClick={() => {
                  helper();
                }}
                disabled={isDisableDraft}
              >
                Save as Draft
              </button>
              <button
                className="btn px-5 m-1 py-2 activity_next_button"
                onClick={(e) => setClick(true)}
                disabled={isDisableNext}
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* ── Dialogs ── */}
      {click && (
        <FirstCreatepublishA
          newActivity={newActivity}
          attachMent={attachMent}
          attachMent2={attachMent2}
          activityState={activityState}
          closeBtn={setClick}
          redirectStateData={state?.redirectStateData ?? null}
          selectedLab={selectedLab}
          entryType={entryType}
          selectedGradeScale={selectedGradeScale}
        />
      )}
      {showLinkBox && (
        <AddLinkPopup
          setShowLinkBox={setShowLinkBox}
          onChangeLinkValue={onChangeLinkValue}
          linkValue={linkValue}
          handleSaveLink={handleSaveLink}
        />
      )}

      {/* Activity Labs Dialog */}
      <Dialog
        open={activityLabsOpen}
        onClose={() => setActivityLabsOpen(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            boxShadow: "0 25px 50px -12px rgba(0,0,0,0.15)",
          },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            px: 3,
            py: 2.5,
            borderBottom: "1px solid #f1f5f9",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <FlaskConical size={22} style={{ color: "#6366f1" }} />
            <Typography
              variant="h6"
              sx={{ fontWeight: 700, color: "#1e293b", fontSize: "1.1rem" }}
            >
              Activity Labs
            </Typography>
          </Box>
          <IconButton
            size="small"
            onClick={() => setActivityLabsOpen(false)}
            sx={{ color: "#94a3b8" }}
          >
            <img src={assets.closeIcon} alt="close" width={20} height={20} />
          </IconButton>
        </DialogTitle>

        <DialogContent
          sx={{
            p: 0,
            backgroundColor: "#f8fafc",
            height: "70vh",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* Fixed Top Search Section */}
          <Box
            sx={{
              position: "sticky",
              top: 0,
              zIndex: 50,
              backgroundColor: "#f8fafc",
              px: 3,
              pt: 3,
              pb: 2,
              borderBottom: "1px solid #e2e8f0",
            }}
          >
            <TextField
              fullWidth
              placeholder="Search activities..."
              size="small"
              value={labSearch}
              onChange={(e) => setLabSearch(e.target.value)}
              sx={{
                mb: 2,
                "& .MuiOutlinedInput-root": {
                  borderRadius: 2,
                  backgroundColor: "#ffffff",
                  fontSize: "0.9rem",
                },
              }}
            />

            <Typography
              variant="body2"
              sx={{
                color: "#64748b",
                fontSize: "0.8rem",
                fontWeight: 500,
              }}
            >
              {filteredLabs.length} activities available
            </Typography>
          </Box>

          {/* Scrollable Activities List */}
          <Box
            onScroll={(e) => {
              const bottom =
                e.target.scrollHeight - e.target.scrollTop <=
                e.target.clientHeight + 50;

              if (bottom && visibleLabsCount < filteredLabs.length) {
                setVisibleLabsCount((prev) => prev + 10);
              }
            }}
            sx={{
              flex: 1,
              overflowY: "auto",
              px: 3,
              py: 2,

              /* scrollbar */
              "&::-webkit-scrollbar": {
                width: "8px",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "#cbd5e1",
                borderRadius: "10px",
              },
            }}
          >
            <Stack spacing={2}>
              {labsLoading ? (
                <div className="text-center py-4">
                  <CircularProgress size={30} />
                </div>
              ) : (
                filteredLabs.slice(0, visibleLabsCount).map((lab) => {
                  const isSelected = selectedLab?.id === lab.id;

                  return (
                    <Paper
                      key={lab.id}
                      elevation={0}
                      onClick={() => setSelectedLab(isSelected ? null : lab)}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 2.5,
                        p: 2.5,
                        borderRadius: 2.5,
                        border: isSelected
                          ? "2px solid #6366f1"
                          : "1px solid #e2e8f0",
                        backgroundColor: isSelected ? "#f5f3ff" : "#ffffff",
                        cursor: "pointer",
                        transition: "all 0.2s ease",

                        "&:hover": {
                          borderColor: "#c4b5fd",
                          boxShadow: "0 4px 12px rgba(99,102,241,0.08)",
                        },
                      }}
                    >
                      <Radio
                        checked={isSelected}
                        onChange={() => setSelectedLab(isSelected ? null : lab)}
                        sx={{
                          color: isSelected ? "#6366f1" : "#cbd5e1",
                          "&.Mui-checked": {
                            color: "#6366f1",
                          },
                          p: 0.5,
                        }}
                      />

                      {/* Thumbnail */}
                      <Box
                        sx={{
                          width: 130,
                          height: 85,
                          flexShrink: 0,
                          borderRadius: 2,
                          overflow: "hidden",
                          border: "1px solid #e2e8f0",
                          backgroundColor: "#f1f5f9",
                        }}
                      >
                        <img
                          src={lab.thumbnailUrl}
                          alt={lab.title}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                          onError={(e) => {
                            e.target.style.display = "none";
                          }}
                        />
                      </Box>

                      {/* Content */}
                      <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Typography
                          variant="h6"
                          sx={{
                            fontSize: "1.05rem",
                            fontWeight: 700,
                            color: "#1e293b",
                            mb: 0.8,
                          }}
                        >
                          {lab.title}
                        </Typography>

                        <Box
                          sx={{
                            display: "flex",
                            gap: 1,
                            mb: 1.2,
                            flexWrap: "wrap",
                          }}
                        >
                          <Chip
                            size="small"
                            label={
                              lab?.estimatedDurationMinutes
                                ? `${lab.estimatedDurationMinutes} mins`
                                : "-"
                            }
                            sx={{
                              backgroundColor: "#e0e7ff",
                              color: "#4338ca",
                              fontWeight: 600,
                              fontSize: "0.75rem",
                              borderRadius: 1.5,
                            }}
                          />

                          <Chip
                            size="small"
                            label={lab.resourceType}
                            sx={{
                              backgroundColor: "#f3e8ff",
                              color: "#7c3aed",
                              fontWeight: 600,
                              fontSize: "0.75rem",
                              borderRadius: 1.5,
                            }}
                          />
                        </Box>

                        <Typography
                          variant="body2"
                          sx={{
                            color: "#64748b",
                            fontSize: "0.82rem",
                            lineHeight: 1.5,
                            display: "-webkit-box",
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                          }}
                        >
                          {lab.description}
                        </Typography>
                      </Box>

                      {/* View Button */}
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={(e) => {
                          e.stopPropagation();

                          const previewData = {
                            selectedLab: lab,
                            activityData: {
                              title: activityState.tittle,
                              description: activityState.description,
                              className: classes.split(",")[0],
                              subjectName: subjects.split(",")[0],

                              chapterName:
                                chapterDropdown
                                  ?.flatMap((item) => item.bookInfo)
                                  ?.flatMap((book) => book.chapterData)
                                  ?.find((chapter) => chapter.id === chapters)
                                  ?.chapterName || "",

                              duration: duration || "20 minutes",
                            },
                          };

                          localStorage.setItem(
                            "activityPreviewData",
                            JSON.stringify(previewData),
                          );

                          const features = [
                            "toolbar=no",
                            "location=no",
                            "directories=no",
                            "status=no",
                            "menubar=no",
                            "scrollbars=yes",
                            "resizable=yes",
                            "fullscreen=yes",
                            `width=${window.screen.availWidth}`,
                            `height=${window.screen.availHeight}`,
                            "top=0",
                            "left=0",
                          ].join(",");

                          const newWindow = window.open(
                            "/activity-lab-preview.html",
                            "_blank",
                            features,
                          );

                          if (newWindow) {
                            newWindow.moveTo(0, 0);

                            newWindow.resizeTo(
                              window.screen.availWidth,
                              window.screen.availHeight,
                            );

                            newWindow.focus();
                          }
                        }}
                      >
                        View Details
                      </Button>
                    </Paper>
                  );
                })
              )}

              {/* Empty */}
              {filteredLabs.length === 0 && (
                <Box sx={{ textAlign: "center", py: 6 }}>
                  <Typography variant="body2" sx={{ color: "#94a3b8" }}>
                    No activities found matching your search
                  </Typography>
                </Box>
              )}
            </Stack>

            {/* Loader */}
            {visibleLabsCount < filteredLabs.length && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  py: 2,
                }}
              >
                <CircularProgress size={24} />
              </Box>
            )}
          </Box>
        </DialogContent>
        <DialogActions
          sx={{
            px: 3,
            py: 2.5,
            borderTop: "1px solid #f1f5f9",
            backgroundColor: "#ffffff",
          }}
        >
          <Button
            variant="outlined"
            onClick={() => setActivityLabsOpen(false)}
            sx={{
              textTransform: "none",
              borderRadius: 2,
              px: 3,
              fontWeight: 600,
              borderColor: "#e2e8f0",
              color: "#64748b",
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={() => setActivityLabsOpen(false)}
            disabled={!selectedLab}
            sx={{
              textTransform: "none",
              borderRadius: 2,
              px: 3,
              fontWeight: 600,
              backgroundColor: "#6366f1",
              "&:hover": { backgroundColor: "#4f46e5" },
              boxShadow: "0 4px 14px rgba(99,102,241,0.35)",
            }}
          >
            {selectedLab ? `Select: ${selectedLab.title}` : "Select Activity"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default CreateActivity;
